import React from 'react';
import Avatar from '@mui/material/Avatar';
import { useRecordContext } from 'react-admin';

const UserPicture = (props) => {
  const record = useRecordContext(props);
  const size = props.size || 100;

  // Always render something: this is the click target for the edit-avatar dialog.
  if (!record?.picture) {
    const initials = `${record?.firstName?.[0] ?? ''}${record?.lastName?.[0] ?? ''}`.toUpperCase();
    return <Avatar sx={{ width: size, height: size }}>{initials || '?'}</Avatar>;
  }

  return (
    <Avatar
      sx={{ width: size, height: size }}
      src={`${process.env.REACT_APP_IMAGES_FILE_HOST}/fit-in/${size}x${size}/${record.picture}`}
      alt="avatar"
    />
  );
};

export default UserPicture;
